import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';
import { Variables } from 'styles/variables/variables';
import { Colors } from 'styles/variables/colors';
import { ReactComponent as CrossSimpleIconComponent } from 'assets/icons/cross-simple.svg';

const { assistant } = Variables;

export const ClientName = styled.div`
    ${TextStyle({ fontSize: '25px', fontWeight: '700', color: Colors.blue })};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
`;

export const ClientNotificationContainer = styled.div`
    word-wrap: break-word;
`;

export const CreatedAt = styled.div`
    ${TextStyle({ fontSize: '15px', fontWeight: '300', fontFamily: assistant })};
    letter-spacing: 0.2px;
    font-style: italic;
    white-space: nowrap;
`;

export const Message = styled.div`
    ${TextStyle({ fontSize: '16px', fontWeight: '600', fontFamily: assistant })};
    display: inline-block;
    letter-spacing: 0px;
    line-height: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 25px);
    display: -webkit-box; /* Required for -webkit-line-clamp to work */
    display: -webkit-box; /* Required for line-clamp to work */
    -webkit-box-orient: vertical; /* Ensure vertical layout */
    -webkit-line-clamp: 2; /* Limit to two lines for WebKit browsers */
    -moz-line-clamp: 2; /* Limit to two lines for Firefox */
    -o-line-clamp: 2; /* Limit to two lines for Opera */
    line-clamp: 2; /* Limit to two lines */
`;

export const NotificationsContainer = styled.div`
    overflow-y: auto;
    height: 500px;
    width: 100%;
`;

export const NotificationContainer = styled.div`
    border-radius: 8px;
    border: 1px solid #f3f4f6ff;
    box-shadow: 0px 10px 20px -15px #171a1f;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1rem 1.5rem 1rem 1.5rem;
    width: inherit;

    :hover {
        background-color: ${Colors.inputBorder};
        border: 1px solid ${Colors.inputBorder};
        cursor: pointer;
    }
`;

export const NotificationsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: inherit;
`;

export const TrashContainer = styled.div`
    text-align: end;
    margin-bottom: 0.5rem;
    cursor: pointer;
`;

export const TopContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const BottomContainer = styled.div`
    ${TextStyle({ fontSize: '16px', fontWeight: '300', fontFamily: assistant })};
    letter-spacing: 0.2px;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

type Props = {
    isActive?: boolean;
};

export const Notification = styled.span<Props>``;

export const Container = styled.div`
    max-width: 389px;
    border: 1px solid #8353e2ff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 4px;
    gap: 0.4rem;
`;

export const CrossSimpleIcon = styled(CrossSimpleIconComponent)`
    fill: ${Colors.darkGray};
`;

export const FullNotification = styled.div`
    ${TextStyle({
        fontSize: '16px',
        fontWeight: '400',
        color: Colors.darkGray,
        fontFamily: Variables.assistant,
    })};
    line-height: 1.2;
    overflow-y: auto;
    max-height: 180px;
    width: 100%;
    padding: 0rem 1rem 0.5rem 1rem;
`;

export const NotificationsHeader = styled.div<{ mobile?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: ${({ mobile }) => (mobile ? 'wrap' : 'nowrap')};
    margin-bottom: 12px;
`;

export const NotificationsTitle = styled.h1`
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: #111827;
    line-height: 1.2;
`;

export const ClearAllButton = styled.button`
    height: 44px;
    padding: 0 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: none;
    border-radius: 14px;
    background: linear-gradient(135deg, #8353e2 0%, #6d41d8 100%);
    box-shadow: 0 12px 24px rgba(131, 83, 226, 0.22);
    color: #ffffff;
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease,
        background 0.2s ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 14px 28px rgba(131, 83, 226, 0.28);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.65;
    }

    svg,
    path {
        fill: currentColor;
    }
`;

export const NotificationsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 0;
`;

export const MessageContainer = styled.div`
    position: relative;
    background: #ffffff;
    border: 1px solid #ece7f9;
    border-radius: 12px;
    padding: 12px 48px 12px 14px;
    box-shadow: 0 6px 18px rgba(38, 16, 78, 0.06);
    display: flex;
    flex-direction: column;
    gap: 10px;
    cursor: pointer;
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease,
        border-color 0.2s ease;

    &:hover {
        transform: translateY(-1px);
        border-color: #d9cef4;
        box-shadow: 0 12px 28px rgba(38, 16, 78, 0.1);
    }
`;

export const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

export const ChatBadge = styled.div`
    background: rgba(131, 83, 226, 0.1);
    color: #6d41d8;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 1.2;
    white-space: nowrap;
`;

export const StatusWrapper = styled.div`
    display: inline-flex;
    border-radius: 999px;
    overflow: hidden;
    border: 1px solid #e5e7eb;
`;

export const ProgramName = styled.p`
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
    color: #4b5563;
    font-size: 13px;
    font-weight: 500;
`;

export const LeftStatusPill = styled.div<{ variant?: 'default' | 'active' }>`
    background: ${({ variant }) => (variant === 'active' ? '#d1fae5' : '#f3f4f6')};
    color: ${({ variant }) => (variant === 'active' ? '#065f46' : '#4b5563')};
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
`;

export const StatusPill = styled.div<{ variant?: 'default' | 'active' }>`
    background: ${({ variant }) => (variant === 'active' ? '#d1fae5' : '#eef2ff')};
    color: ${({ variant }) => (variant === 'active' ? '#065f46' : '#4338ca')};
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    border-left: 1px solid #e5e7eb;
`;

export const MessageText = styled.p`
    font-size: 15px;
    font-family: Montserrat, sans-serif;
    color: #1f2937;
    margin: 0;
    line-height: 1.45;
    word-break: break-word;
`;

export const FooterRow = styled.div`
    display: flex;
    justify-content: flex-end;
    font-size: 12px;
    font-weight: 500;
    color: #6b7280;
    white-space: nowrap;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 999px;
    background: transparent;
    cursor: pointer;
    color: #6b7280;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition:
        background 0.2s ease,
        color 0.2s ease;

    &:hover {
        background: rgba(131, 83, 226, 0.08);
        color: #6d41d8;
    }
`;

export const BodyWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 16px;
    flex-wrap: wrap;
`;

export const SearchbarContainer = styled.div<{ mobile: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
    ${({ mobile }) =>
        !mobile &&
        `
    column-gap: 16px;
    padding: 10px 16px;
    border-radius: 12px;
    border: 1px solid #ece7f9;
    background: #ffffff;
    box-shadow: 0 6px 18px rgba(38, 16, 78, 0.06);
    `}
    ${({ mobile }) =>
        mobile &&
        `
    flex-direction: column;
    align-items: stretch;
    `}
`;

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 32px 24px;
    margin-top: 0;
    border-radius: 12px;
    border: 1px dashed #d9cef4;
    background: #faf8ff;
    color: #6b7280;
    text-align: center;
`;

export const EmptyTitle = styled.p`
    margin: 0;
    color: #111827;
    font-size: 16px;
    font-weight: 700;
`;

export const EmptySubtitle = styled.p`
    margin: 0;
    color: #6b7280;
    font-size: 13px;
`;
